module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "search-icon.97eb6137.png" + "?" + Date.now();